// @flow
import styled from "styled-components";
import { Td } from "../../components/TableX";
import { below } from "../../assets/css/media";

export const TdStat = styled(Td)`
	&.active {
		background: #00ff9a;
		color: #003a31;
	}

	${below.phone`
		.player-avatar {
			display: none;
		}
	`};
	min-width: calc(3.5em - 10px);
`;

export default TdStat;


// WEBPACK FOOTER //
// ./src/components/Draft/TdStat.js